import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBoschComponent } from './simple-icons-bosch.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBoschComponent ],
    exports:      [ SimpleIconsBoschComponent ],
    bootstrap:    []
})
export class SimpleIconsBoschModule {}
